<template>
  <div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <!-- 상품 카테고리 -->
    <template v-if="isAdmin">
      <a id="sb_category"></a>
      <div class="columns is-multiline">
        <div class="column is-full">
          <div class="box">
            <admin-box-item title="카테고리 선택*">
              <div class="columns is-multiline"
                   style="margin-top: -28px !important">
                <div class="column is-full">
                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="catArr1"
                                     :selectVal="selectedCategory(prod.category1_id, 'cat1')"
                                     @onSelect="res => clickCategory(res.value, 'cat1')"
                                     placeholder="1차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="cat2"
                                     :selectVal="selectedCategory(prod.category2_id, 'cat2')"
                                     @onSelect="res => clickCategory(res.value, 'cat2')"
                                     placeholder="2차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="cat3"
                                     :selectVal="selectedCategory(prod.category3_id, 'cat3')"
                                     @onSelect="res => clickCategory(res.value, 'cat3')"
                                     placeholder="3차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                </div>
              </div>
            </admin-box-item>
          </div>
        </div>
      </div>
    </template>
    <template v-if="isAdmin">
      <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="테마 선택*">
            <admin-form-item label="테마" style="margin-top:20px">
              <lp-adm-drop-input :data.sync="themelist"
                                 :selectVal="prod.theme"
                                 @onSelect="selectTheme"
                                 added_field="type"
                                 placeholder="검색 후 선택"
                                 width="250px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
            </admin-form-item>
          </admin-box-item>
        </div>
      </div>
    </div>
    </template>

    <div class="columns is-multiline">
      <div class="column is-7">

        <!-- 상품 기본정보 -->
        <a id="sb_product_basic"></a>
        <div class="box">
          <admin-box-item title="상품 기본정보">
            <div class="columns is-multiline">
              <div class="column is-3" v-if="isAdmin">
                <admin-form-item label="노출 우선순위">
                  <input class="input" style="width:50px"
                         v-model.number="prod.priority"
                         placeholder="노출 우선순위를 입력하세요. (0~99)"
                         type="number">
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="isAdmin">
                <admin-form-item label="파트너*">
                  <lp-adm-drop-input :data.sync="partners"
                                    :selectVal="partnerName"
                                    @onSelect="res => partner_id = res.value"
                                    placeholder="검색 후 선택"
                                    listAlign="left"
                                     width="250px"
                                    style="display:inline-block; margin-right:12px;"></lp-adm-drop-input>
                  <lp-check-bool :checkedVal.sync="isEqualPartner"
                  label="파트너 정보와 상품 정보가 동일합니다."></lp-check-bool>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품 대표 이미지" :desc="getRatio('product_card')">
                  <drag-img-single :img.sync="prod.first_img"></drag-img-single>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품 이미지" :desc="getRatio('product_detail_slider')">
                  <drag-img-multiple :imgs.sync="prod.imgs"></drag-img-multiple>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품 노출 여부">
                  <lp-radio :val="prod.enable_prod"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'노출',value:true}, {label:'비노출', value:false}]"
                      @onSelect="onSelectedProdState"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품명*">
                  <input class="input"
                        :value="prod.name"
                        @input="e => prod.name = e.target.value"
                         placeholder="상품명을 입력해주세요."
                        type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품 한줄 설명">
                  <input class="input"
                        :value="prod.simple_desc"
                        @input="e => prod.simple_desc = e.target.value"
                         placeholder="상품에 대한 간단한 설명을 하는 곳 입니다."
                        type="text" maxlength="70">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품 태그"
                                  desc="상품 검색 시 키워드로 활용됩니다"
                                  tip="최대 10개까지 등록 가능합니다.">
                  <lp-input-tag :data="prod.tags"></lp-input-tag>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품위치"
                                 desc="파트너의 주소와 다른 경우 별도로 입력하면 해당상품은 상품위치 기반으로 유저에게 노출됩니다."
                                  :notRequired="true">
                  <lp-address :data.sync="prod.address"></lp-address>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 맞춤 DB -->
        <a id="sb_custom_db"></a>
        <div class="box">
          <admin-box-item title="맞춤 DB">
            <div class="columns is-multiline">
              <div class="column is-full"
                    v-for="(param, index) in prod_param"
                    v-bind:key="'param_input'+index">
                <admin-form-item :label="param.name">

                  <input-param :param.sync="param"></input-param>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 상품 상세정보 -->
        <div class="box">
          <admin-box-item title="상품 상세정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item>
                  <lp-editor :text.sync="prod.info"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 상품 공통 고시정보 -->
        <div class="box">
          <admin-box-item title="상품 공통 고시정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item>
                  <lp-check-bool :checkedVal.sync="prod.custom_common_info"
                                  label="개별 고시 정보 사용여부"></lp-check-bool>
                  <div class="prod-reg-content">
                    <div class="flex" style="font-size: .9rem;">
                      <div class="lp-tab" :class="{'lp-tab-selected':selectedTab===0}" @click="selectedTab=0">상품 정보 제공 고시</div>
                      <div class="lp-tab" :class="{'lp-tab-selected':selectedTab===1}" @click="selectedTab=1">배송안내</div>
                      <div class="lp-tab" :class="{'lp-tab-selected':selectedTab===2}" @click="selectedTab=2">교환 및 반품안내</div>
                    </div>
                    <div class="lp-tab-content">
                      <div v-show="selectedTab === 0">
                        <lp-editor :text.sync="prod.common_info.use_info"></lp-editor>
                      </div>
                      <div v-show="selectedTab === 1">
                        <lp-editor :text.sync="prod.common_info.delivery_info"></lp-editor>
                      </div>
                      <div v-show="selectedTab === 2">
                        <lp-editor :text.sync="prod.common_info.refund_info"></lp-editor>
                      </div>
                    </div>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-5">

        <!-- 상품 주문/전환 퍼포먼스 정보 -->
        <!--<div class="box" v-if="$route.query.id && is_modify">
          <admin-box-item title="상품 주문/전환 퍼포먼스 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                &lt;!&ndash; <admin-form-item label=""> &ndash;&gt;
                <div style="display: flex; flex-wrap: wrap;">
                  <div class="service-conversion-info">
                    <span class="label service-conversion-info-label">
                      상품 문의</span>
                    <div class="flex">
                      <span class="label">{{ performance.inquiry }}</span>
                      <span class="label">건</span>
                    </div>
                  </div>
                  <div class="service-conversion-info">
                    <span class="label service-conversion-info-label">
                      상품 찜</span>
                    <div class="flex">
                      <span class="label">{{ performance.like }}</span>
                      <span class="label">건</span>
                    </div>
                  </div>
                  <div class="service-conversion-info">
                    <span class="label service-conversion-info-label">
                      상품후기</span>
                    <div class="flex">
                      <span class="label">{{ performance.review }}</span>
                      <span class="label">건</span>
                    </div>
                  </div>
                </div>
                &lt;!&ndash; </admin-form-item> &ndash;&gt;
              </div>
            </div>
          </admin-box-item>
        </div>-->

        <!-- 가격 정보 -->
        <div class="box" v-if="isLaunchpack">
          <admin-box-item title="가격 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="판매가격 사용여부">
                  <lp-radio :val.sync="prod_price.price_type"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용',value:0}, {label:'대체문구 사용', value:1}]"></lp-radio>
                </admin-form-item>
              </div>
              <template v-if="prod_price.price_type === 0">
                <div class="column is-7">
                  <admin-form-item label="판매가격">
                    <div class="flex">
                      <input class="input full has-text-right"
                              v-model="prod_price.price"
                              @input="e => setNumber(e, 'prod_price', 'price', 10)"
                              type="number" maxlength="10">
                      <label class="label" style="margin: 4px 0px 0px 12px;">원</label>
                    </div>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="결제 방식">
                    <lp-radio :val.sync="prod_price.is_subscription"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'건 결제', value:false}, {label:'정기 결제',value:true}]"></lp-radio>
                    <div class="desc" v-if="prod_price.is_subscription">* 판매가격으로 월단위 정기 결제됩니다.</div>
                    <div v-if="prod_price.is_subscription" style="padding:16px 0 24px 0">
                      <button class="button is-primary" @click="clickAddSubscription">결제 주기 추가</button>
                      <div class="flex-align" v-for="(item,idx) in prod_price.subscriptions" :key="'subscription-'+idx"
                          style="margin-top:8px">
                        <div style="margin-right:4px">주기</div>
                        <input type="number" v-model="item.date_unit" style="width:40px">
                        <!--<div style="margin:0 4px 0 20px">월별 금액</div>
                        <input type="number" v-model="item.price"><div style="margin-left:4px">원</div>-->

                        <div style="margin-left:20px">
                          <lp-radio :val.sync="item.discount_type"
                                    value_name="value"
                                    label_name="label"
                                    :showInput="true"
                                    :block="true"
                                    @onSelect="res=> setSubscriptionValue(res, item)"
                                    @onEdit="res => setSubscriptionValue(res, item)"
                                    :data="[{label:'할인율', value:0, num: item.discount_rate, unit:'%'},
                                    {label:'할인액', value:1, num: item.price, unit:'원'}]"></lp-radio>
                        </div>
                        <i class="material-icons unselect" @click="clickDeleteSubs(idx)"
                           style="padding:2px;font-size:16px;margin-left:4px">close</i>
                      </div>
                    </div>
                  </admin-form-item>
                </div>
              </template>
              <!--<div class="column is-5" v-if="prod_price.price_type === 0">
                <admin-form-item label="판매가격 기준단위">
                  <div class="flex align-center">
                    <div style="margin: 0 10px; padding-bottom:4px; color:#555555">{{ prod_price.unit }}</div>
                    <button class="button is-primary is-bordered">설정</button>
                  </div>
                </admin-form-item>
              </div>-->
              <div class="column is-full" v-if="prod_price.price_type === 1">
                <admin-form-item label="판매가격 대체문구">
                  <span class="select">
                    <select v-model="prod_price.price_text" @change="e => prod_price.price_text=e.target.value">
                      <option value="관리자에게 문의">관리자에게 문의</option>
                      <option value="파트너에게 문의">파트너에게 문의</option>
                    </select>
                  </span>
                  <!--<button class="button is-primary is-bordered" style="margin-left:8px">설정</button>-->
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="판매 기간">
                  <div class="flex" style="flex-wrap:wrap">
                    <div style="align-items: center;">
                      <admin-date-picker
                        type="datetime"
                        :data="prod_price.start_date"
                        @setDate="date => selDateMin(date, 'price')"></admin-date-picker>
                    </div>
                    <div class="lp-dating">&#126;</div>
                    <div style="align-items: center;">
                      <admin-date-picker
                        type="datetime"
                        :data="prod_price.end_date"
                        @setDate="date => selDateMax(date, 'price')"></admin-date-picker>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="1회 최대 주문수량">
                  <input class="input product-short-input"
                         v-model="prod.maximum"
                         @input="e => setNumber(e, 'prod', 'maximum', 5)"
                         type="number" maxlength="3">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="할인">
                  <lp-radio :val.sync="prod_price.is_discount"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                </admin-form-item>
              </div>
              <div v-if="prod_price.is_discount">
                <div class="column is-full">
                  <admin-form-item label="할인가격">
                  <lp-radio :val.sync="prod_price.discount_type"
                            value_name="value"
                            label_name="label"
                            @update:val="calcPrice()"
                            :showInput="true"
                            :block="true"
                            @onEdit="res => onEdit(res,'discount')"
                            :data="[{label:'할인율', value:0, num: prod_price.discount_rate, unit:'%'},
                                    {label:'할인액', value:1, num: prod_price.discount_price, unit:'원'}]"></lp-radio>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="할인 후 판매가격">
                    <label class="label"
                            style="padding-left: 4px;">
                    {{ prod_price.saleOriginPrice | currency }}
                    </label>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="할인 기간">
                    <div class="flex" style="flex-wrap:wrap">
                      <div style="align-items: center;">
                        <admin-date-picker
                          type="datetime"
                          :data="prod_price.discount_start"
                          @setDate="date => selDateMin(date, 'discount')"></admin-date-picker>
                      </div>
                      <div class="lp-dating">&#126;</div>
                      <div style="align-items: center;">
                        <admin-date-picker
                          type="datetime"
                          :data="prod_price.discount_end"
                          @setDate="date => selDateMax(date, 'discount')"></admin-date-picker>
                      </div>
                    </div>
                  </admin-form-item>
                </div>
              </div>
              <div class="column is-full" v-if="isAdmin">
                <admin-form-item label="수수료">
                  <lp-radio :val.sync="prod_price.is_comm"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                </admin-form-item>
              </div>
              <div v-if="prod_price.is_comm">
                <div class="column is-full">
                  <admin-form-item label="수수료">
                    <lp-radio :val.sync="prod_price.comm_type"
                              value_name="value"
                              label_name="label"
                              :showInput="true"
                              :block="true"
                              @onEdit="res => onEdit(res, 'comm')"
                              :data="[{label:'수수료율', value:0, num: prod_price.comm_rate, unit:'%'},
                                      {label:'수수료금액', value:1, num: prod_price.comm_price, unit:'원'}]"></lp-radio>
                  </admin-form-item>
                </div>
              </div>
              <div class="column is-full">
                <admin-form-item label="포인트">
                  <lp-radio :val.sync="prod_price.is_point"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                </admin-form-item>
              </div>
              <div v-if="prod_price.is_point">
                <div class="column is-full">
                  <admin-form-item label="포인트">
                    <lp-radio :val.sync="prod_price.point_type"
                              value_name="value"
                              label_name="label"
                              :showInput="true"
                              :block="true"
                              @onEdit="res => onEdit(res, 'point')"
                              :data="[{label:'포인트율', value:0, num: prod_price.point_rate, unit:'%'},
                                      {label:'포인트금액', value:1, num: prod_price.point, unit:'원'}]"></lp-radio>
                  </admin-form-item>
                </div>
              </div>
              <div class="column is-full">
                <admin-form-item label="재고사용여부">
                  <lp-radio :val.sync="prod.enable_stock"
                            value_name="value"
                            label_name="label"
                            @onSelect="res => prod.enable_stock=res"
                            :data="[{label:'재고사용',value:true},{label:'무한대',value:false}]"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="prod.enable_stock">
                <admin-form-item label="재고수">
                  <input class="input product-short-input"
                         v-model="prod.stock"
                         @input="e => setNumber(e, 'prod', 'stock', 8)"
                         type="number">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="품절 여부">
                  <lp-radio :val.sync="prod.soldout"
                            value_name="value"
                            label_name="label"
                            @onSelect="res => prod.soldout=res"
                            :data="[{label:'품절',value:true},{label:'정상',value:false}]"></lp-radio>
                </admin-form-item>
              </div>

            </div>
          </admin-box-item>
        </div>

        <!-- 상품 옵션 정보 -->
        <a id="sb_product_option"></a>
        <div class="box">
          <admin-box-item title="상품 옵션 정보" :showToggleButton="true">
            <div class="columns is-multiline relative">
              <div class="column is-full">
                <admin-form-item label="옵션 사용여부">
                  <lp-radio :val.sync="prod.enable_option"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="prod.enable_option">
                <admin-form-item label="옵션 설정">
                  <button class="button is-primary" @click="$modal.show('optionModal')">상품 옵션 구성</button>
                </admin-form-item>
              </div>

            </div>


            <launchpack-product-option-stocks :selectors="selectorStocks"
                                   :requiredOptionStockUsing="requiredOptionStockUsing"
                                   @checkRequiredOption="checkRequiredOption"
                                   :requiredOptionTitle="requiredOptionTitle"
                                   v-if="prod.enable_option"></launchpack-product-option-stocks>
          </admin-box-item>
        </div>

        <!-- 상품 재고 설정 -->
        <div class="box">
          <admin-box-item title="상품 재고 설정" :showToggleButton="true">
            <div class="columns is-multiline">
              <!-- 재고 사용여부 -->
              <div class="column is-full">
                <admin-form-item v-if="selectors.length === 0"
                                 label="재고 사용여부">
                  <lp-radio :val.sync="prod.stock_type"
                            value_name="value"
                            label_name="label"
                            @onSelect="res => prod.stock_type=res"
                            :data="[{label:'사용',value:0},{label:'무한대',value:1}]"></lp-radio>
                </admin-form-item>
                <div class="label"
                     v-if="selectors.length > 0">상품 옵션 재고의 합</div>
              </div>
              <!-- 재고 사용 -->
              <div v-if="prod.stock_type===0 && selectors.length === 0">
                <!-- 입고 수량 -->
                <div class="column is-full flex-align">
                  <admin-form-item label="입고">
                    <div style="display:flex;align-items: center">
                      <input class="input product-short-input"
                             v-model="addCount"
                             @keyup.enter="addStock"
                             type="number">
                      <button class="button is-primary"
                              style="margin-left:8px;width:48px"
                              @click="addStock">추가</button>
                    </div>
                  </admin-form-item>
                </div>
                <!-- 주문 수량 -->
                <div class="column is-full" v-if="$route.query.id">
                  <admin-form-item label="주문 수량"
                                   justifyContent="space-between"
                                   :isFlex="true">
                    {{ prod.ordered_count }}개
                  </admin-form-item>
                </div>
                <!-- 재고 수량 -->
                <div class="column is-full" v-if="$route.query.id">
                  <admin-form-item label="재고 수량"
                                   justifyContent="space-between"
                                   desc="재고 수량이 0개 인 경우에는 자동 '품절'처리 됩니다."
                                   :isHeaderBlock="true"
                                   :isFlex="true">
                    {{prod.stock}}개</admin-form-item>
                </div>
              </div>

              <!-- 상품 옵션 재고의 합 -->
              <div class="column is-full" v-if="selectors.length > 0">
                <div v-if="selectors.length > 0">
                  <div class="flex" style="justify-content: space-between;width:100%;line-height:1.7rem"
                       v-for="(selector,idx) in selectorStocks" :key="'selector-'+idx">
                    <div>{{ selector.name }}</div>
                    <div>{{ selector.stock }}개 남음 / 누적 {{ selector.ordered_count }} 개 주문</div>
                  </div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 주문 가능 수량 한도 -->
        <div class="box">
          <admin-box-item title="주문 가능 수량 한도" :showToggleButton="true">
            <!-- 판매기간 있을 시 남은 판매 가능 시간 들어갈 곳 -->
            <div>
              <admin-form-item
                style="margin-bottom:20px"
                label="1회 최소 ~ 최대 주문 수량 한도">
                <input class="input product-short-input"
                       v-model.number="prod.minimum"
                       @input="e => setNumber(e, 'prod', 'minimum', 5)"
                       type="number" maxlength="3">
                <div class="lp-dating">&#126;</div>
                <input class="input product-short-input"
                       v-model.number="prod.maximum"
                       @input="e => setNumber(e, 'prod', 'maximum', 5)"
                       type="number" maxlength="3">
                <div class="flex" v-if="prod.order_conversion_type===11">
                  <div class="lp-txt-period" style="margin-right:28px">{{ periodDateText(prod.minimum) }}</div>
                  <div class="lp-txt-period">{{ periodDateText(prod.maximum) }}</div>
                </div>
                <div v-if="errorQuantity" style="font-size: 0.8rem;color: #db2828;margin-top: 8px;">
                  <span>1회 최소~최대 주문 수량</span> 설정이 잘못되었습니다.</div>
              </admin-form-item>

              <admin-form-item label="옵션별 설정"
                               v-if="prod.enable_option">
                <div v-if="requiredOptionTitle" class="flex-align">
                  <div style="margin-right:8px;width:50%">{{ requiredOptionTitle }}</div>
                  <input class="input product-short-input"
                         :value="requiredOptionMin"
                         @input="e=>inputRequiredOptionQuantity(e, 'minimum')"
                         type="number" maxlength="3">
                  <div class="lp-dating">&#126;</div>
                  <input class="input product-short-input"
                         :value="requiredOptionMax"
                         @input="e=>inputRequiredOptionQuantity(e, 'maximum')"
                         type="number" maxlength="3">
                </div>

                <div v-for="(opt,idx) in selectors" :key="'prod-limit-'+idx" class="flex-align" style="margin-top:8px" v-if="opt.option_type===1">
                  <div style="margin-right:8px;width:50%">{{ opt.name }}</div>
                  <input class="input product-short-input"
                         :value="opt.minimum"
                         @input="e=>inputAddOptionQuantity(e, 'minimum', opt)"
                         type="number" maxlength="3">
                  <div class="lp-dating">&#126;</div>
                  <input class="input product-short-input"
                         :value="opt.maximum"
                         @input="e=>inputAddOptionQuantity(e, 'maximum', opt)"
                         type="number" maxlength="3">
                </div>
              </admin-form-item>
            </div>
          </admin-box-item>
        </div>

        <!--<div class="box" v-if="isLaunchpack">
          <admin-box-item title="옵션 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <div v-for="(op, idx) in option" :key="idx" class="lp-master-option-list">
                  <div style="margin-right:8px">{{ op.name }}</div>
                  <div v-if="op.type===0">
                    <span v-if="op.discount>0">({{ op.discount }}% 할인) / </span><span>1회 결제 / {{ optionPrice(op) | currency }}</span>
                  </div>
                  <div v-if="op.type===1">
                    <div v-if="op.is_first">
                      <span>첫달만 ({{op.first_discount}}% 할인) {{ firstOptionDiscountPrice(op) | currency }}<br> {{ op.date_unit }} 개월 </span><span v-if="op.discount>0">({{ op.discount }}% 할인) / </span><span>정기 결제 / {{ optionPrice(op) }}원</span>
                    </div>
                    <div v-else>
                      <span>{{ op.date_unit }} 개월 </span><span v-if="op.discount>0">({{ op.discount }}% 할인) / </span><span>정기 결제 / {{ optionPrice(op) | currency }}</span>
                    </div>
                  </div>
                  <div>
                    <button class="button half" @click="modifyMasterOption(op)" v-if="op.id>0">수정</button>
                    <button style="margin-left:4px" class="button half is-danger" @click="deleteMasterOption(op, idx)">삭제</button>
                  </div>
                </div>
              </div>
              <div class="column is-full">
                <button class="button is-primary" style="width:100%" @click="addMasterOption">옵션 추가하기</button>
              </div>
            </div>
          </admin-box-item>
        </div>-->

        <!-- 상품 링크 -->
        <div class="box">
          <admin-box-item title="상품 링크">
            <input class="input"
                   :value="prod.link"
                   @input="e => { prod.link = e.target.value; }"
                   type="text">
          </admin-box-item>
        </div>
        <div class="box">
          <admin-box-item title="소스파일">
            <input-file  acceptExt=".zip" description="압축파일(zip)만 가능합니다."
                        :value.sync="prod.files"
                        :maxLength="1"></input-file>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-full" v-if="isAdmin">
        <!-- 연관 상품 -->
        <a id="sb_related_product"></a>
        <div class="box tab-item">
          <admin-box-item title="관련 상품">
            <related-products :products.sync="prod.related_products"></related-products>
          </admin-box-item>
        </div>
      </div>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="lp-loading" v-if="loading">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
    </div>

    <!-- 마스터 옵션 팝업 -->
    <modal name="masterOption" :adaptive="true" :width="600" height="auto" class="modal-style">
      <master-option :op="selectedOption" @setOption="setMasterOption"></master-option>
    </modal>

    <!-- 기본 옵션 팝업 -->
    <modal name="optionModal" :adaptive="true" :width="800" height="auto" class="modal-style" @closed="closeOption">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 옵션 구성" :useTab="false"
                        subtitle="상품 옵션을 직접 구성하거나 옵션 템플릿에서 가져와서 구성할 수 있습니다.">
          <launchpack-prod-option :selectors="selectors"
                                  :is_modify="is_modify"
                                  @closeOption="closeOption"
                                  :category1="prod.category1_id"
                                  :category2="prod.category2_id"
                                  :category3="prod.category3_id"></launchpack-prod-option>
        </admin-box-item>
      </div>
    </modal>

  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import moment from 'moment'
  import InputImg from '../../module/common/InputImg'

  import {SweetModal} from 'sweet-modal-vue'

  import LpAdmBtn from '../../module/common/LpAdmBtn'
  import LpSortDropDown from "../../module/common/LpSortDropDown"
  import LpCheckBool from "../../module/common/LpCheckBool"
  import LpCheckGroup from '../../module/common/LpCheckGroup'
  import LpRadio from "../../module/common/LpRadio"
  import LpInput from "../../module/common/LpInput"
  import LpInputText from "../../module/common/LpInputText"
  import LpInputTag from "../../module/common/LpInputTag"
  import LpAddress from '../../module/common/LpAddress'
  import LpDropdown from "../../module/common/LpDropdown"
  import LpProdOption from "../../module/common/LpProdOption"
  import LpRegionDropDown from "../../module/common/LpRegionDropDown"

  import Vue from 'vue'
  import InputParam from "../../module/custom/InputParam";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import LpEditor from "../../module/common/LpEditor";
  import InputFile from "../../module/common/InputFile";
  import MasterOption from "../../module/custom/MasterOption";
  import LpProdOptionStocks from "../../module/common/LpProdOptionStocks";
  import LaunchpackProductOptionStocks from "../../module/common/LaunchpackProductOptionStocks";
  import LaunchpackProdOption from "../../module/common/LaunchpackProdOption";
  import RelatedProducts from "./component/RelatedProducts";
  import DragImgMultiple from "../../module/common/DragImgMultiple";
  import DragImgSingle from "../../module/common/DragImgSingle";

  export default {
    layout: 'Main',
    components: {
      DragImgSingle,
      DragImgMultiple,
      RelatedProducts,
      LaunchpackProdOption,
      LaunchpackProductOptionStocks,
      LpProdOptionStocks,
      MasterOption,
      InputFile,
      draggable,
      LpEditor,
      LpAdmDropInput,
      InputParam,
      LpDropdown,
      LpInputTag,
      LpInputText,
      LpInput,
      LpRadio,
      LpCheckBool,
      LpCheckGroup,
      LpSortDropDown,
      SweetModal,
      InputImg,
      LpAdmBtn,
      LpAddress,
      LpProdOption,
      LpRegionDropDown
    },
    watch:{
      'prod_price.discount_type'(n){
        if (n === 0)
          this.prod_price.saleOriginPrice = parseInt(this.prod_price.price) - (this.prod_price.price * parseInt(this.prod_price.discount_rate) / 100);
        else
          this.prod_price.saleOriginPrice = parseInt(this.prod_price.price) - parseInt(this.prod_price.discount_price);
      },
      isEqualPartner(n){
        if(n && this.partner_id>0){
          this.equalPartner();
        }
      },
      'prod.category1_id'(n){
        this.cat2 = this.get_cat(this.catArr2, n);
      },
      'prod.category2_id'(n){
        this.cat3 = this.get_cat(this.catArr3, n)
      },
    },
    created() {
      if(this.$route.query.id)
        this.is_modify=true;

      // 1. 패키지들 2. 카테고리들 3. 상품정보 순서대로 가져온다.
      this.getData();
      this.getThemeList();
      if(this.isAdmin) {
        this.$axios.get(this.getUrl('partner/simple')).then(res => {
          this.partners = res.data;
        })
      }
    },
    data() {
      return {
        packages: [],
        // 선택된 팩
        selectedPack: 0,
        // 커머스 팩(string)
        commercePack: '',
        loading: false,
        isEqualPartner: false,
        is_modify:false,
        selectedTab: 0,
        partners: [],
        // 상품 종류 선택
        prodType: ['견적요청', '배송상품'],
        selType: '견적요청',
        showContainer: true,  //원래 false 테스트용으로 true로 바꿔놈
        // mode가 partner일경우는 vuex에서 partner id가져옴
        partner_id:0,
        // 주문, 전환 정보
        performance:{
          inquiry: 0,
          like: 0,
          review: 0
        },
        // 상품 기본 정보,
        prod:{
          priority: 99,
          order_conversion_type: 0,
          stock: 0,
          maximum: 99,
          minimum: 1,
          stock_type: 1,
          soldout: false,
          enable_stock: false,
          enable_prod: true,
          enable_option: false,
          related_products: [],
          first_img: '',
          imgs:[''],
          files: [],
          simple_desc:'',
          info:'',
          name:"",
          category1_id:'',
          category2_id:'',
          category3_id:'',
          // 상품 공통 정보
          custom_common_info:true,
          common_info:{
            use_info:'',
            delivery_info:'',
            refund_info:'',
          },
          address:{
            sido: '',
            sigungu: '',
            dong: '',
            detail: '',
            post_code: '',
            old: '',
            new: ''
          },
          tags:[]
        },
        // 맞춤 DB
        param_list:[],
        // 상품 가격 정보
        prod_price:{
          unit: 'kg',            // 단위
          start_date:'',
          end_date:'',
          is_subscription: false,
          subscriptions: [],
          is_discount: false,
          is_comm: false,
          is_point: false,
          price: 0,
          price_type:0,
          price_text:'',
          discount_type: 0,
          discount_rate: 0,
          discount_price: 0,
          delivery_price: 0,
          comm_rate:0,
          comm_price:0,
          comm_type:0,
          discount_start:'',
          discount_end:'',
          point_type:0,
          point:0,
          point_rate:0
        },
        // 상품 검색 정보
        prod_seo:{
          title:"",
          author:"",
          desc:"",
          keyword:""
        },
        prod_param: [],
        // 옵션
        selectors:[],
        // 옵션 - 재고수량
        selectorStocks: [],
        // 카테고리
        catArr1: [],
        cat2: [],         //1차 카테고리 관련된 카테고리만
        cat3: [],         //2차 카테고리 관련된 카테고리만
        catArr2: [],
        catArr3: [],
        // 상품가격 대체 문구
        priceTexts: [
          {
            label: '파트너에게 문의',
            value: '파트너에게 문의'
          },
          {
            label: '관리자에게 문의',
            value: '관리자에게 문의'
          }
        ],
        // 활성 비활성 상태
        status: {
          // 상품 기본정보
          prodInfo: [
            {
              id: 0,
              title: '카테고리',
              img: require('../../../assets/image/product_db/01_cat.png'),
              usage: {
                active: true,
                value: true
              },
              essential: {
                active: true,
                value: true
              }
            },
            {
              id: 0,
              title: '파트너',
              img: require('../../../assets/image/product_db/02_partner.png'),
              usage: {
                active: true,
                value: true
              },
              essential: {
                active: true,
                value: true
              }
            },
            {
              id: 0,
              title: '상품 대표 이미지',
              img: require('../../../assets/image/product_db/03_img.png'),
              usage: {
                active: false,
                value: true
              },
              essential: {
                active: true,
                value: true
              }
            },
            {
              id: 0,
              title: '상품 노출 여부',
              img: require('../../../assets/image/product_db/04_display.png'),
              usage: {
                active: true,
                value: true
              },
              essential: {
                active: true,
                value: false
              }
            },
            {
              id: 0,
              title: '상품명',
              img: require('../../../assets/image/product_db/05_name.png'),
              usage: {
                active: true,
                value: true
              },
              essential: {
                active: true,
                value: true
              }
            },
            {
              id: 0,
              title: '상품 한줄 설명',
              img: require('../../../assets/image/product_db/06_description.png'),
              usage: {
                active: false,
                value: true
             },
              essential: {
                active: false,
                value: true
              }
            },
            {
              id: 0,
              title: '상품 태그',
              img: require('../../../assets/image/product_db/07_tag.png'),
              usage: {
                active: true,
                value: true
              },
              essential: {
                active: true,
                value: true
              }
            },
            {
              id: 0,
              title: '상품 위치',
              img: require('../../../assets/image/product_db/08_address.png'),
              usage: {
                active: true,
                value: true
              },
              essential: {
                active: true,
                value: true
              }
            }
          ],
          // 추가된 맞춤 DB필드
          prodCustom: [
            //   {
            //     title: '텍스트 필드',
            //     img: require('../../../assets/image/custom_db/db_text.png'),
            //     usage: {
            //       active: true,
            //       value: true
            //     },
            //     essential: {
            //       active: true,
            //       value: true
            //     },
            //     activate : {
            //       value: true,
            //     }
            //   },
            //   {
            //     title: '숫자(정수)',
            //     img: require('../../../assets/image/custom_db/db_integer.png'),
            //     usage: {
            //       active: true,
            //       value: true
            //     },
            //     essential: {
            //       active: true,
            //       value: true
            //     },
            //     activate : {
            //       value: true,
            //     }
            //   },
            //   {
            //     title: '숫자(실수)',
            //     img: require('../../../assets/image/custom_db/db_real.png'),
            //     usage: {
            //       active: true,
            //       value: true
            //     },
            //     essential: {
            //       active: true,
            //       value: true
            //     },
            //     activate : {
            //       value: true,
            //     }
            //   },
            //   {
            //     title: '세부 옵션 사항',
            //     img: require('../../../assets/image/product_db/10_detail_option.png'),
            //     usage: {
            //       active: true,
            //       value: true
            //     },
            //     essential: {
            //       active: true,
            //       value: true
            //     },
            //     activate : {
            //       value: true,
            //     }
            //   },
            //   {
            //     title: '서비스 가능 지역',
            //     img: require('../../../assets/image/product_db/09_available_region.png'),
            //     usage: {
            //       active: true,
            //       value: true
            //     },
            //     essential: {
            //       active: true,
            //       value: true
            //     },
            //     activate : {
            //       value: true,
            //     }
            //   },
            //   {
            //     title: '주소',
            //     img: require('../../../assets/image/product_db/08_address.png'),
            //     usage: {
            //       active: true,
            //       value: true
            //     },
            //     essential: {
            //       active: true,
            //       value: true
            //     },
            //     activate : {
            //       value: true,
            //     }
            //   }
            // ],
          ],
          // 상품 공통 정보
          common_info: [
            {
              id: 0,
              title: '이용 안내',
              name: '이용 안내',
              img: require('../../../assets/image/product_db/11_common_info.png'),
              usage: {
                active: false,
                value: true
              },
              essential: {
                active: true,
                value: true
              }
            },
            {
              id: 0,
              title: '환불/취소 안내',
              name: '환불/취소 안내',
              img: require('../../../assets/image/product_db/11_common_info.png'),
              usage: {
                active: true,
                value: true
              },
              essential: {
                active: true,
                value: true
              }
            }
          ],
        },
        // 마스터용 옵션리스트
        option: [],
        selectedOption: {
          id: 0,
          type: 0,
          date_unit: 1,
          price: 0,
          discount: 0,
          is_first: false
        },
        themelist: [],
        theme:'',
      }
    },
    computed: {
      partnerName(){
        if(this.partners.length>0){
          for(let i=0; i<this.partners.length; i++){
            if(this.partners[i].value===this.partner_id){
              return this.partners[i].name;
              break;
            }
          }
        }
      },
      requiredOptionMin () {
        let minimum = 0;
        for(let i=0; i<this.selectors.length; i++) {
          if(this.selectors[i].option_type===0) {
            minimum = this.selectors[i].minimum;
            break;
          }
        }
        return minimum;
      },
      requiredOptionMax () {
        let maximum = 0;
        for(let i=0; i<this.selectors.length; i++) {
          if(this.selectors[i].option_type===0) {
            maximum = this.selectors[i].maximum;
            break;
          }
        }
        return maximum;
      },
      // 필수 옵션 재고 사용 여부
      requiredOptionStockUsing () {
        let stock_using = false;
        for(let i=0; i<this.selectors.length; i++) {
          if(this.selectors[i].option_type===0) {
            stock_using = this.selectors[i].stock_using;
            break;
          }
        }
        return stock_using;
      },
      requiredOptionTitle () {
        let text = '';
        this.selectors.forEach(item => {
          if(item.option_type===0) {
            text ? text += ` X ${item.name}`: text += item.name
          }
        })
        return text;
      },
      errorQuantity () {
        return this.prod.minimum > this.prod.maximum;
      },
    },
    methods: {
      clickDeleteSubs(idx) {
        removeIndex(this.prod_price.subscriptions, idx);
      },
      clickAddSubscription() {
        this.prod_price.subscriptions.push({
          date_unit: 3,
          price: 0,
          discount_rate: 0,
          discount_type: 0
        })
      },
      // 테마 선택 ( 마스터 백오피스용 )
      selectTheme(res) {
        this.prod.theme_id = res.value;
        this.theme = res.label;
      },
      // 마스터 백오피스용
      getThemeList() {
        this.$axios.get('public/theme/whole').then(res=>{
          this.themelist = res.data;
        });
      },
      // 옵션 가격 ( 마스터 백오피스 )
      optionPrice(option) {
        if(option) {
          return option.price - (option.price * option.discount / 100)
        }
      },
      // 첫달만 할인 가격 ( 마스터 백오피스 )
      firstOptionDiscountPrice(option) {
        if(option) {
          return option.price - (option.price * option.first_discount / 100)
        }
      },
      // 옵션 수정 ( 마스터 백오피스 )
      modifyMasterOption(option){
        this.selectedOption = option;
        this.$modal.show('masterOption');
      },
      // 옵션 삭제 ( 마스터 백오피스 )
      deleteMasterOption(option, idx){
        if(option.id===0){
          removeIndex(this.option,idx);
        }
        else {
          this.$axios.delete(this.getUrl(`product/${this.$route.query.id}/option/${option.id}`)).then(res=>{
            if(res.status===200) {
              this.toast('옵션이 삭제되었습니다.');
              removeIndex(this.option,idx);
            }
          })
        }
      },
      // 옵션 선택 ( 마스터 백오피스 )
      setMasterOption(option){
        if(option.id===0) this.option.push(option);
        else {
          for(let i=0; i<this.option.length; i++){
            if(this.option[i].id===option.id){
              this.option[i] = option;
            }
          }
        }
        this.$modal.hide('masterOption');
        this.selectedOption = {
          id: 0,
          type: 0,
          date_unit: 1,
          price: 0,
          discount: 0,
          is_first: false
        };
      },
      // 옵션 추가하기 ( 마스터 백오피스 )
      addMasterOption(){
        this.selectedOption = {
          id: 0,
          type: 0,
          date_unit: 1,
          price: 0,
          discount: 0,
          is_first: false
        };
        this.$modal.show('masterOption');
      },
      // 선택된 팩 string으로 반환 ( ex) commerce )
      integerToStringSelectedPack() {
        return this.packages[this.selectedPack];
      },
      // 인풋 숫자 입력시 max_length 조건에 맞춰서 return
      setNumber(e, depth1, depth2, max_length){
        if(e.target.value.length > max_length) this[depth1][depth2] = parseInt(e.target.value.substr(0,max_length));
        else this[depth1][depth2] = parseInt(e.target.value);
      },
      // 선택된 카테고리의 상품종류들 띄우기
      isCategoryMatchingPack(pack){
        for(let x=0; x<this.packages.length; x++){
          if(this.packages[x].name==='launchpack'){
            return false;
          }
        }
        let get_pack = []
        // 카테고리별 상품종류(팩 종류) 배열에 담기
        for(let i=0; i<this.catArr1.length; i++){
          if(this.prod.category1_id === this.catArr1[i].value){
            get_pack = this.catArr1[i].packages;
            break;
          }
        }
        for (let j=0; j<get_pack.length; j++){
          // all 일경우 패키지들 다 반환시킴
          if(get_pack[j] === 'all') {
            return pack;
          }
          // 상품종류에 맞게 반환
          else if(get_pack[j] === pack) {
            return pack;
            break;
          }
        }
      },
      clickCategory(value, type) {
        if (type === 'cat1') {
          this.prod.category1_id = value;
          this.prod.category2_id = '';
          this.prod.category3_id = '';
          this.selectedPack = 0;
        }
        else if (type === 'cat2') {
          this.prod.category2_id = value;
          this.prod.category3_id = '';
        }
        else if (type === 'cat3') {
          this.prod.category3_id = value;
        }
      },
      selectedCategory(cat_id, type) {
        if (type === 'cat1' && cat_id) {
          for(let i=0; i<this.catArr1.length; i++) {
            if (this.catArr1[i].value === cat_id){
              return this.catArr1[i].label;
              break;
            }
          }
        }
        else if (type === 'cat2' && cat_id) {
          for(let j=0; j<this.cat2.length; j++) {
            if (this.cat2[j].value === cat_id){
              return this.cat2[j].label;
              break;
            }
          }
        }
        else if (type === 'cat3' && cat_id) {
          for(let x=0; x<this.cat3.length; x++) {
            if (this.cat3[x].value === cat_id){
              return this.cat3[x].label;
              break;
            }
          }
        }
      },
      selDateMin(date, type){
        if(type==='price') this.prod_price.start_date=date;
        else if(type==='discount') this.prod_price.discount_start=date;
      },
      selDateMax(date, type){
        if(type==='price') this.prod_price.end_date=date;
        else if(type==='discount') this.prod_price.discount_end=date;
      },
      equalPartner() {
        this.$axios.get(this.getUrl('partner/' + this.partner_id)).then(res => {
          if (res.status === 200) {
            this.prod.name = res.data.partner.name
            this.prod.address = res.data.partner.address
            this.prod.info = res.data.partner.info
          }
        })
      },
      // 상품 노출 여부
      onSelectedProdState(val) {
        this.prod.enable_prod = val;
      },
      setSubscriptionValue(res, item) {
        if(res.hasOwnProperty('text')) {
          if(res.value===0) {
            item.discount_rate = parseInt(res.text);
            item.price = this.prod_price.price - (this.prod_price.price * item.discount_rate / 100)
          } else {
            item.price = parseInt(res.text);
          }
        } else {
          if(res===0) {
            item.price = this.prod_price.price - (this.prod_price.price * item.discount_rate / 100);
          }
        }
      },
      // radio edit반환값
      onEdit(res, type) {
        if( type==='discount' ){
          if (res.value === 0) {
            this.prod_price.discount_rate = parseInt(res.text);
          }
          else {
            this.prod_price.discount_price = parseInt(res.text);
          }
          this.calcPrice();
        }
        else if ( type === 'comm' ){
          if (res.value === 0) {
            this.prod_price.comm_rate = parseInt(res.text);
          }
          else {
            this.prod_price.comm_price = parseInt(res.text);
          }
        }
        else if ( type === 'point' ){
          if (res.value === 0) {
            this.prod_price.point_rate = parseInt(res.text);
          }
          else {
            this.prod_price.point = parseInt(res.text);
          }
        }
      },
      saveData(){
        let err = '';
        if(!this.prod.category1_id) err = '카테고리를 선택해주세요.';
        if(err === '' && !this.partner_id) err = '파트너를 선택하세요.';
        if(err === '' && !this.prod.name) err = '상품이름을 입력하세요.';

        if(err){
          this.toast(err);
          return;
        }

        this.$store.commit('setLoading', true);
        let url='';
        // 수정시
        if(this.is_modify) {
          url=this.getUrl('product/'+this.$route.query.id);
          let prod = this.cloneItem(this.prod);
          prod.partner_id = this.partner_id;
          if(this.selectedPack!==''){
            prod.package = this.integerToStringSelectedPack();
          }

          let prod_price = this.cloneItem(this.prod_price);
          if(!this.prod_price.start_date){
            prod_price.start_date = '1111-01-01';
          }
          if(!this.prod_price.end_date) {
            prod_price.end_date = '9999-01-01';
          }

          this.$axios.patch(url,{
            product: prod,
            price: prod_price,
            seo: this.prod_seo,
            params: this.prod_param,
            selectors: this.selectors,
            option: this.option,
            selectorStocks: this.selectorStocks
          }).then(res=>{
            if(res.status===200 && res.data.detail==='success'){
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.getData();
            }
          }).catch(error=>{
            this.$store.commit('setLoading', false);
            if (error.response) {
              this.toast(error.response.data.message);
            }
          });
        }
        // 등록시
        else {
          url = this.getUrl('product');
          let prod = this.cloneItem(this.prod);
          prod.partner_id = this.partner_id;
          if(this.selectedPack!==''){
            prod.package = this.integerToStringSelectedPack();
          }

          let prod_price = this.cloneItem(this.prod_price);
          if(!this.prod_price.start_date){
            prod_price.start_date = '1111-01-01';
          }
          if(!this.prod_price.end_date){
            prod_price.end_date = '9999-01-01';
          }

          this.$axios.post(url,{
            product: prod,
            price: prod_price,
            seo: this.prod_seo,
            params: this.prod_param,
            selectors: this.selectors,
            option: this.option,
            selectorStocks: this.selectorStocks
          }).then(res=>{
            if(res.status===200 && res.data.detail==='success'){
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('product'));
            }
          }).catch(error=>{
            this.$store.commit('setLoading', false);
            if (error.response) {
              this.toast(error.response.data.message);
            }
          });
        }
      },
      partner() {
        return {
          value: this.prodInfo.partner_id,
          label: find(this.partners, 'value', this.prodInfo.partner_id).label
        }
      },
      types() {
        return {
          value: this.prodInfo.types,
          label: find(this.type_opts, 'value', this.prodInfo.types).label
        }
      },
      calcPrice() {
        if (this.prod_price.discount_type === 0)
          this.prod_price.saleOriginPrice = parseInt(this.prod_price.price) - (this.prod_price.price * parseInt(this.prod_price.discount_rate) / 100);
        else
          this.prod_price.saleOriginPrice = parseInt(this.prod_price.price) - parseInt(this.prod_price.discount_price);
      },
      paramAllList(){
        // 파라미터 리스트
        this.$axios.get(this.getUrl('product/param')).then(res=>{
          if(res.status===200){
            this.param_list = res.data;

            let result = this.paramChecker(this.param_list, this.prod_param)
            if(result.length > 0) this.prod_param = this.prod_param.concat(result);
          }
        })
      },
      getData(){
        if(this.$route.query.id) {
          // 상품 상세 가져오기
          this.$axios.get(this.getUrl('product/' + this.$route.query.id))
            .then(res => {
              if (res.status === 200) {
                if(!res.data.price.subscriptions) {
                  res.data.price.subscriptions = [];
                }
                if(!res.data.product.files) {
                  res.data.product.files = [];
                }
                this.prod = res.data.product;
                this.prod_price = res.data.price;
                this.prod_seo = res.data.seo;
                this.partner_id = res.data.product.partner;
                this.prod_param = res.data.params;
                this.performance = res.data.performance;

                this.selectors = res.data.selectors.map(i => {
                  i.options.forEach(o => {
                    o.add = 0;
                    if(!o.subscriptions) {
                      o.subscriptions = [];
                    }
                  })
                  return i;
                })
                this.closeOption();

                /* 마스터 백오피스일 경우만 */
                if(res.data.option){
                  this.option = res.data.option
                }

                this.conversionInfo = res.data.serviceInfo;

                if(!res.data.product.address){
                  this.prod.address = {
                    sido: '',
                    sigungu: '',
                    dong: '',
                    detail: '',
                    post_code: '',
                    old: '',
                    new: ''
                  }
                }

                for(let i=0; i<res.data.params.length; i++){
                  if(res.data.params[i].param_type===5 && !res.data.params[i].value_address){
                    res.data.params[i].value_address = {
                      sido: '',
                      sigungu: '',
                      dong: '',
                      detail: '',
                      post_code: '',
                      old: '',
                      new: ''
                    }
                  }
                }

                if(!this.prod.tags){
                  this.prod.tags = [];
                }

                this.paramAllList();
                //this.getPackages();
                this.getCats();
              }
            });
        }
        else {
          this.paramAllList();
          //this.getPackages();
          this.getCats();
        }
      },
      // Store에 저장되있는 팩 목록 가져오기
      getPackages(){
        this.packages = this.$store.getters.getPackages;

        // 선택된 팩이 있을 경우 selectedPack에 integer로 선택된 값 넘겨주기
        if(this.prod.package){
          for(let i=0; i<this.packages.length; i++){
            if(this.packages[i] === this.prod.package){
              this.selectPackage(i);
              break;
            }
          }
        }
      },
      // 팩목록과 비교해서 선택된 팩을 다시 저장
      selectPackage(idx){
        this.selectedPack = idx;
        // 커머스 일 경우 커머스 내 종류 호출하기 ( 다운로드 팩 또는 일반 배송상품 return 값은 string)
        if(this.integerToStringSelectedPack()==='commerce') {
          this.$axios.get('public/service/commerce/package').then(res=> {
             this.commercePack = res.data;
          });
        }
        //this.getCats();
      },
      getCats(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('category'))
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name, packages: cat.packages});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            this.getPackages();
            this.cat2 = this.get_cat(this.catArr2, this.prod.category1_id);
            this.cat3 = this.get_cat(this.catArr3, this.prod.category2_id);
          });
      },
      // 추가 옵션 최소, 최대 주문 수량
      inputAddOptionQuantity (e, type, selector) {
        let value = parseInt(e.target.value);
        selector[type] = value;
        for(let i=0; i<selector.options.length; i++) {
          selector.options[i][type] = value;
        }
      },
      // 필수 옵션 최소, 최대 주문 수량
      inputRequiredOptionQuantity (e, type) {
        let value = parseInt(e.target.value)
        for(let i=0; i<this.selectors.length; i++) {
          if(this.selectors[i].option_type===0) {
            this.selectors[i][type] = value;

            if(type==='minimum') {
              if(this.selectors[i]['minimum'] > this.selectors[i]['maximum']) {
                this.selectors[i]['minimum'] = this.selectors[i]['maximum'];
              }
              if(this.selectors[i]['minimum'] < 1) {
                this.selectors[i]['minimum'] = 1;
              }
            }
            if(type==='maximum') {
              if(this.selectors[i]['minimum'] > this.selectors[i]['maximum']) {
                this.selectors[i]['maximum'] = this.selectors[i]['minimum'];
              }
            }

            let selector = this.selectors[i];
            for(let j=0; j<selector.options.length; j++) {
              selector.options[j][type] = value;
              // console.log(selector, selector.options[j], type, value)
            }
          }
        }
      },
      // 입고수량 재고 수량에 추가하기
      addStock() {
        this.prod.add = parseInt(this.prod.add ? this.prod.add : 0) + parseInt(this.addCount);
        if(this.stockCount === 0) {
          this.stockCount = this.prod.stock;
        }
        this.prod.stock = this.stockCount + this.prod.add;
        this.addCount = 0;
      },
      checkRequiredOption (value) {
        for(let i=0; i<this.selectors.length; i++) {
          if(this.selectors[i].option_type===0) {
            this.selectors[i].stock_using=value;
          }
        }
      },
      // 옵션 팝업 꺼질때
      closeOption() {
        this.selectorStocks = [];

        if(this.prod.order_conversion_type === 10 || this.prod.order_conversion_type === 11) {
          // this.selectorStocks = this.selectors;
          // 속성 옵션
          let propOptions = findArray(this.selectors, 'option_type', 0);
          if(propOptions.length>0) {
            this.opt([], propOptions, 0);
          }

          // 추가 옵션
          let addOptions = findArray(this.selectors, 'option_type', 1);
          // console.log(addOptions)
          this.selectorStocks = this.selectorStocks.concat(addOptions)
          /*for(let i=0; i<addOptions.length; i++) {
            for(let j=0; j<addOptions[i].options.length; j++) {
              let item = addOptions[i].options[j];
              this.selectorStocks.push({
                option_type: 1,
                options: [item],
                name: item.name,
                price: item.price,
                enable_stock: false,
                add: 0,
                stock: 0,
                ordered_count: 0,
                addCount: 0,
                stockCount: 0,
              });
            }
          }*/


        }
        else {
          // 속성 옵션
          let propOptions = findArray(this.selectors, 'option_type', 0);
          if(propOptions.length>0) {
            this.opt([], propOptions, 0);
          }

          // 추가 옵션
          let addOptions = findArray(this.selectors, 'option_type', 1);
          for(let i=0; i<addOptions.length; i++) {
            for(let j=0; j<addOptions[i].options.length; j++) {
              let item = addOptions[i].options[j];
              this.selectorStocks.push({
                option_type: 1,
                options: [item],
                name: item.name,
                price: item.price,
                enable_stock: false,
                add: 0,
                stock: 0,
                ordered_count: 0,
                addCount: 0,
                stockCount: 0,
              });
            }
          }
          if(this.$route.query.id) {
            this.$axios.post(this.getUrl(`product/${this.$route.query.id}/selector_stocks`), {stocks: this.selectorStocks})
              .then( res => {
                this.selectorStocks = res.data.stocks;
              });
          }
        }
        this.$modal.hide('optionModal');
      },
      opt(str, all, cur) {
        for(let i=0; i<all[cur].options.length; i++) {
          let item = all[cur].options[i];
          let arr = this.cloneItem(str);
          arr.push(item);
          if(cur === all.length-1) {
            let name = '';
            let price = 0;
            arr.forEach(arr_item => {
              if(name !== '') name += ' x ';
              name += arr_item.name;
              price += parseInt(arr_item.price);
            });
            this.selectorStocks.push({
              option_type: 0,
              options: arr,
              name: name,
              price: price,
              enable_stock: false,
              add: 0,
              stock: 0,
              ordered_count: 0,
              addCount: 0,
              stockCount: 0,
            });
          } else {
            // 재귀호출
            this.opt(arr, all, cur+1);
          }
        }
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .product-short-input
    width 89px

  .lp-reg-category-box
    width 100%
    display flex

  .lp-reg-category
    border-radius 3px
    border 1px solid $warmgrey
    color $font
    margin-right 20px
    width calc(33% - 12px)
    height fit-content

  .lp-reg-category:last-child
  .lp-reg-category-un:last-child
    margin-right 0

  .lp-reg-category div
  .lp-reg-category-un div
    padding 8px
    text-align center
    font-size 0.9rem
    cursor pointer

  .lp-reg-category div
    border-bottom 1px solid $warmgrey

  .lp-reg-category div:last-child
    border-bottom 0
  .lp-reg-category div:hover
    background $warmgrey

  .lp-reg-category div.select
    background $primary
    color white

  .lp-reg-category-un
    border-radius 3px
    border 1px solid $warmgrey
    color $font
    width calc(33% - 10px)
    height fit-content
    margin-right 20px

  .lp-reg-category-un div
    border-bottom 1px solid $primary

  .lp-reg-category-un div:last-child
    border-bottom 0

  .lp-reg-category div.selected
    background $primary
    color white

  .lp-tab
    display flex
    padding 10px 24px
    color #555

  .lp-tab-selected
    border: 1px solid #ccc;
    border-bottom: 1px solid #fff;
    color: #555;
    border-radius: 3px;

  .service-conversion-info
    display flex
    justify-content space-evenly
    max-width 50%
    min-width 50%
    padding 4px 8px

  .service-conversion-info-label
    display inline-block
    width 112px
    min-width 80px
    margin 0

  .prod-reg-content
    margin-top 12px

  .lp-master-option-list
    width 100%
    border 1px solid #d4d4d4
    padding 8px 16px
    display flex
    justify-content space-between
    margin-bottom: 6px

  .desc
    margin-top 8px
    font-size 0.9rem
    color #989898
</style>
